import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';

import './StoredDocumentViewerModal.scss';

type Props = {
  documentUrl: string;
  show: boolean;
  onClose: () => void;
};

const StoredDocumentViewerModal = ({ documentUrl: url, show, onClose }: Props) => (
  <>
    {show && (
      <div id="stored-document-viewer-modal">
        <div className="stored-document-viewer-modal__content">
          <div className="stored-document-viewer-modal__actions">
            <Button type="button" mods="u-spaceBottomMd" onClick={() => onClose()}>
              Close
            </Button>
          </div>
          <div className="stored-document-viewer-modal__embed">
            {(isPdf(url) && <embed src={url} type="application/pdf" />) ||
              (isImage(url) && <img src={url} alt="Stored Document" />) || (
                <div className="stored-document-viewer-modal__download">
                  Oops, looks like we can't view this file here. Would you like to
                  <Button
                    type="link"
                    mods="u-spaceRightSm u-spaceLeftSm u-fontSizeLg underline"
                    onClick={() => window.open(url, '_blank')}
                  >
                    download
                  </Button>
                  this file instead?
                </div>
              )}
          </div>
        </div>
      </div>
    )}
  </>
);

const isImage = (url: string): boolean =>
  ['png', 'jpg', 'jpeg'].some((extension) => getFileExtension(url).includes(extension));

const isPdf = (url: string): boolean => getFileExtension(url).includes('pdf');

const getFileExtension = (url: string): string => new URL(url).pathname.split('.').pop();

export default StoredDocumentViewerModal;
